import { CCol, CRow } from "@coreui/react";
import React from "react";

export default function SectionTitle({
  align,
  subTitle,
  Title,
  subtitle,
  style2,
  desc,
}) {
  return (
    <>
      <div className={`section-title-wrapper text-${align}`}>
        <div className="section-title-content">
          {subtitle && (
            <h4 className={`${style2 === true ? "style2" : ""}`}>{subTitle}</h4>
          )}
          <h2>{Title}</h2>
          {desc !== "" ?  (<CRow className="justify-content-center"><CCol lg={7}><p className="mb-0">{desc}</p></CCol></CRow>) : <></>}
        </div>
      </div>
    </>
  );
}
